<template>
  <div class="selectAddress">
    <el-dialog width="700px" title="添加地址" top="20px"
      @open="openDialog"
      :close-on-click-modal="false"
      :visible.sync="dialogShow">
      <p class="tip">最多创建{{Count.totalCount}}个地点，您还可以创建{{Count.residueCount}}个地点</p>
      <el-radio-group @change='radioChange' style='margin-bottom: 30px; margin-top: 10px;' v-model="radio">
        <el-radio-button label="1">历史创建地点</el-radio-button>
        <el-radio-button label="2" v-show="Count.residueCount > 0">新地点</el-radio-button>
      </el-radio-group>
      <div class='box1' v-show="newAddressAble">
        <el-form ref='formData' :model="formData">
          <el-row :gutter="20">
            <el-col :span="8">
            <el-form-item prop="city" label="城市" :label-width="formLabelWidth">
              <el-select
                ref='selectCitys'
                class='selectCitys'
                v-model="formData.city"
                value-key="id"
                placeholder="请选择城市"
                @change="cityChange"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(item) in cityList"
                  :key="item.name"
                  :label="item.name"
                  :value="item">

                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item prop="address" label="地点" :label-width="formLabelWidth">
              <el-select
                v-model="formData.address"
                filterable
                remote
                reserve-keyword
                placeholder="请输入地址"
                :remote-method="remoteMethod"
                @change="addressSelectHandle"
                :popper-append-to-body="false"
                :loading="loading">
                <el-option
                  v-for="(item, index) in placeListAlis"
                  :key="item.uid"
                  :label="item.displayname"
                  :value="index">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item prop="region" label="限制在多少米范围用车" :label-width="formLabelWidth">
              <el-select
                ref='selectRegion'
                class='selectRegion'
                v-model="formData.region"
                placeholder="请选择范围"
                @change="rangeHandle"
                :popper-append-to-body="false"
              >
                <el-option label='500米' :value="500"></el-option>
                <el-option label='1000米' :value="1000"></el-option>
                <el-option label='1500米' :value="1500"></el-option>
                <el-option label='2000米' :value="2000"></el-option>

              </el-select>
            </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <label class="el-form-qqmap_title">地图预览</label>
        <div class="qqmap_box" ref='selectAddressId'>
        </div>
      </div>
      <div class="box2" v-show="logAddressAble">
        <history-addresses :resetAble='dialogFormVisible' :disAbleData='disAbleData' @historyAddressHandle='historyAddressHandle' />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="okbtnHandle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* global qq */
import {mapState, mapActions} from 'vuex'
import { Message } from 'element-ui'
import HistoryAddresses from './HistoryAddresses'
import imgTuding from 'Images/img_tuding.png'

export default {
  name: 'SelectAddress',
  components: {
    HistoryAddresses
  },
  data () {
    return {
      formLabelWidth: 'auto',
      dialogShow: false,
      loading: false,
      formData: {
        region: '',
        city: '',
        address: '',
        center: {}
      },
      // addressList: [],
      map: '',
      centerDefault: {
        lng: 116.39672132492065,
        lat: 39.912593280334505
      },
      radio: '1',
      historyAddressData: [],
      newAddressAble: false,
      logAddressAble: true
    }
  },
  props: ['callback', 'dialogFormVisible', 'disAbleData'], // 必传回调, 参数为选择的地址数据 Array
  computed: {
    ...mapState('selectAddress', {
      cityList: 'cityList',
      placeListAlis: state => {
        return [...state.placeList]
      },
      addressAlis: 'address'
    }),
    ...mapState('fenceData', [
      'Count',
      'createSuc',
      'deleteSuc'
    ])
  },
  mounted () {
    // this.getCityList()
    this.getFenceCount()
  },
  watch: {
    dialogFormVisible: function (params) {
      this.dialogShow = this.dialogFormVisible
      // 当剩余可创建地点为 0 时候，展示历史地点
      if (params && this.Count.residueCount === 0) {
        this.radioChange('1')
        this.radio = '1'
      }
    },
    dialogShow: function (params) {
      this.$emit('update:dialogFormVisible', params)
      if (!params) {
        this.resetAllData()
      }
    },
    placeListAlis: function (params) {
      let len = params.length
      if (params && len > 0) {
        this.loading = false
      }
    },
    addressAlis: function (params) {
      let paramsNew = {
        area: params.cityid,
        uid: new Date().getTime(),
        ...params
      }
      if (this.placeListAlis.length !== 0) {
        this.placeListAlis.splice(this.placeListAlis.length - 1, 1, paramsNew)
      } else {
        this.placeListAlis.push(paramsNew)
      }
      this.formData.address = this.placeListAlis.length // 先赋值一个其他值
      this.$nextTick(function () {
        this.formData.city = {id: paramsNew.cityid + '', name: paramsNew.city}
        this.formData.address = this.placeListAlis.length - 1 // 下个事件循环 再赋值为拖动的值 的 index
      })
      // console.log('params:address', this.address, this.formData.address)
    },
    deleteSuc: function (params) {
      if (params.id) {
        this.getFenceCount()
      }
    },
    createSuc: function (params) {
      if (params.id) {
        // console.log('this.selectedData', this.selectedData)
        this.callback({...this.selectedData, fenceId: params.id})
        this.getFenceCount()
        this.getFenceList()
      }
    }
  },
  methods: {
    openDialog () {
      this.$nextTick(() => {
        this.initMap()
      })
    },
    // 初始化 qq 地图
    initMap () {
      const self = this
      let center = {
        lat: self.centerDefault.lat,
        lng: self.centerDefault.lng
      }
      this.formData.center = {...center}
      if (qq && qq.maps) {
        let centerMap = new qq.maps.LatLng(center.lat, center.lng)
        let map = new qq.maps.Map(this.$refs.selectAddressId, {
          center: centerMap,
          zoom: 14,
          mapTypeControl: false,
          panControl: false,
          zoomControl: false
        })

        self.map = map
        self.map.pointer = self.mapPointer(centerMap, map)
        self.map.circle = self.mapCircle(centerMap, map)
      }
    },
    // 腾讯地图api 画点
    mapPointer (center, map) {
      const self = this
      var marker = new qq.maps.Marker({
        position: center,
        map: map,
        // draggable: true, // 禁用地图拖动
        animation: qq.maps.MarkerAnimation.BOUNCE
      })
      let anchor = new qq.maps.Point(12, 36)
      let size = new qq.maps.Size(23, 36)
      let scaleSize = new qq.maps.Size(23, 36)
      let origin = new qq.maps.Point(0, 0)
      let markerIcon = new qq.maps.MarkerImage(
        imgTuding,
        size,
        origin,
        anchor,
        scaleSize
      )
      // 禁用地图拖动
      // qq.maps.event.addListener(marker, 'dragend', function (e) {
      //   self.dragHandle(e.latLng)
      // })
      marker.setIcon(markerIcon)
      return marker
    },
    // 腾讯地图api 画圆
    mapCircle (center, map, range) {
      let color = new qq.maps.Color(82, 188, 163, 0.1)
      let region = Number(range) || 500
      this.formData.region = region
      return new qq.maps.Circle({
        map: map,
        center: center,
        radius: region,
        fillColor: color,
        strokeColor: '#52BCA3',
        strokeWeight: 1
      })
    },
    // 地图拖动
    dragHandle (center) {
      let centerdata = {
        ...center,
        phone: '11000000705'
      }
      this.getMapAdress(centerdata)
      this.redrawPointAndCircle(center)
    },
    // 重新绘制 地图标注
    redrawPointAndCircle (centerp, range) {
      const { center, region } = this.formData
      let centerNew = Object.assign({}, center, centerp)
      let rangNew = range || region

      this.formData.center = {...centerNew}
      this.formData.region = rangNew

      let centerMap = new qq.maps.LatLng(centerNew.lat, centerNew.lng)
      this.map.panTo(centerMap)
      this.map.pointer.setPosition(centerMap)
      this.map.circle.setVisible(false)
      this.map.circle = this.mapCircle(centerMap, this.map, rangNew)
    },
    // 选择范围处理
    rangeHandle (v) {
      console.log('rangeHandle===>', v)
      this.redrawPointAndCircle({}, v)
    },
    cityChange (v) {
      this.formData.address = ''
      this.resetVuexData('placeList')
    },
    // 远程搜索 地点搜索处理
    remoteMethod (query) {
      this.loading = true
      if (this.cityList.length === 0 || this.formData.city === '') {
        this.loading = false
        Message({
          message: '请先选择城市',
          type: 'warning',
          center: true
        })
        return
      }
      this.placeSuggestion({
        query,
        city_id: this.formData.city.id,
        city: this.formData.city.name
      })
    },
    addressSelectHandle (v) {
      let data = this.placeListAlis[v]
      this.redrawPointAndCircle(data)
    },
    // 选择历史地点的回调
    historyAddressHandle (data) {
      this.historyAddressData = [...data]
      // console.log('historyAddressHandle', e)
    },
    okbtnHandle () {
      let data = {}
      let formData = this.formData
      let historyAddressData = [...this.historyAddressData]
      if (this.newAddressAble) {
        if (formData.address === '' || !formData.city) {
          return Message({
            message: '请填写完整信息',
            type: 'warning',
            center: true
          })
        }
        data.address = this.placeListAlis[formData.address]
        data.address = data.address
        data.city = formData.city
        data.range = formData.region
        data.text = `${data.city.name.indexOf('市') > -1 ? data.city.name : data.city.name + '市'} ${data.address.displayname} ${data.range}米`
        // this.addressList.push(data)
        this.dialogShow = false
        this.selectedData = {...data}
        this.createFence({fence: data})
      } else {
        this.dialogShow = false
        this.historyAddressData = []
        this.$emit('historyCallback', [...historyAddressData])
      }
    },
    resetAllData () {
      // this.selectedData = {}
      this.formData.city = ''
      this.formData.address = ''
      this.resetVuexData('placeList')
      // this.resetVuexData('address')
    },
    radioChange (v) {
      this.newAddressAble = v === '2'
      this.logAddressAble = v === '1'
    },
    ...mapActions('selectAddress', [
      'placeSuggestion',
      'getMapAdress',
      'resetVuexData'
    ]),
    ...mapActions('fenceData', [
      'getFenceCount',
      'createFence',
      'getFenceList'
    ])
  }
}
</script>
<style lang='stylus'>
  .qqmap_box {
    height: 350px;
  }
  .selectAddress .el-dialog__footer {
    text-align: center;
    padding: 10px 20px 40px;
  }
  .selectAddress .el-input .el-input__inner {
    width: 100%;
  }
  .selectAddress .el-dialog__body {
    overflow: hidden;

  }
  .tip {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #FF8252;
    background: #FFF2ED;
    width: 150%;
    padding: 0 20px;
    transform: translate(-20px, -20px);
  }
</style>
